import { useTheme } from "@emotion/react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
} from "@mui/material";
import {
  currencyFormat,
  currencyFormatNoDecimals,
} from "../../../../../../components/NewDetail/calculations/utils";

const FlatSheet = (props) => {
  const { flatSheet } = props;
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  if (!flatSheet) return null;

  return (
    <Box {...props}>
      <Typography variant="h6">
        Flat Sheet -{" "}
        {currencyFormatNoDecimals(
          Math.round(
            Number(
              flatSheet &&
                flatSheet.flatSheetCalculations &&
                flatSheet.totalSellPrice
                ? flatSheet.totalSellPrice
                : 0.0
            )
          )
        )}
      </Typography>
      <TableContainer component={Box} sx={{ marginTop: "8px" }}>
        <Table size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell>Width (in.)</TableCell>
              <TableCell align="right">Qty</TableCell>
              <TableCell align="right">Price Per Flat Sheet</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {flatSheet.width}
              </TableCell>
              <TableCell align="right">{flatSheet.quantity}</TableCell>
              <TableCell align="right">
                {currencyFormat(flatSheet.pricePerPiece ?? 0)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default FlatSheet;
